import { all, fork } from 'redux-saga/effects'

import ApiSagas from './api/sagas'
import AppSagas from './app/sagas'

function* allListeners() {
  yield all([ApiSagas.listeners(), AppSagas.listeners()])
}

export default function* rootSaga() {
  yield fork(allListeners)
}
